import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AnimatedLogo from '../components/AnimatedLogo';
import '../css/Header.css';

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <AnimatedLogo />
        </Link>
      </div>
      <button
        className={`hamburger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(prev => !prev)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className={`menu${menuOpen ? ' menu-open' : ''}`}>
        <Link to="/solutions" className={location.pathname === '/solutions' ? 'active' : ''} onClick={closeMenu}>Solutions</Link>
        <Link to="/vision" className={location.pathname === '/vision' ? 'active' : ''} onClick={closeMenu}>Vision</Link>
        <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={closeMenu}>Contact</Link>
        {/* About us link hidden — page/route kept for later, see App.js /about route */}
        <Link to="/policy" className={location.pathname === '/policy' ? 'active' : ''} onClick={closeMenu}>Policy</Link>
        <Link to="/webchat" className={location.pathname === '/webchat' ? 'active' : ''} onClick={closeMenu}>Account</Link>
      </nav>
    </header>
  );
}

export default Header;